import { render, staticRenderFns } from "./FeedbackMedia.vue?vue&type=template&id=2dfb879c&scoped=true&"
import script from "./FeedbackMedia.vue?vue&type=script&lang=js&"
export * from "./FeedbackMedia.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMedia.vue?vue&type=style&index=0&id=2dfb879c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb879c",
  null
  
)

export default component.exports